import React from "react";
import { Row, Col } from "antd";
import Input from "../../../Common/Components/Input";
import SmallButton from "../../../Content/Shared/SmallButton";
import PasswordValid from "../../../Common/Components/PasswordValid";
import styled from "styled-components";

function SignupForm() {
  const [state, setState] = React.useState({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: "",
    repassword: "",
    company: "",
    promotioncode: "",
    appName: "",
    deviceToken: "",
    recaptcha: "",
  });

  function handleChange(evt) {
    setState({ ...state, [evt.target.name]: evt.target.value });
  }
  function submitForm(evt) {
    evt.preventDefault();
    alert("form was submitted");
  }

  return (
    <styleWrapper>
      <div className="fancy-box">
        <form type="POST">
          <h3 className="pt-3 mt-1">Create your account</h3>
          <p>
            I would like xiQ to reach out to me to discuss how Workbench can benefit my organization’s sales and
            marketing efforts
          </p>

          <Row gutter={30}>
            <Col span={12}>
              <Input
                label="First name"
                placeholder="Enter First Name…"
                type="text"
                value={state.firstname}
                name="firstname"
                onChange={handleChange}
              />
            </Col>
            <Col span={12}>
              <Input
                label="Last name"
                placeholder="Enter Last Name…"
                type="text"
                value={state.lastname}
                name="lastname"
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Input
            label="Company"
            placeholder="Enter your company name…"
            type="text"
            name="company"
            value={state.company}
            onChange={handleChange}
          />
          <Input
            name="phone"
            label="Phone number"
            placeholder="+1 123 456 7890"
            type="tel"
            value={state.phone}
            onChange={handleChange}
          />
          <Input
            name="promotioncode"
            label="Code (optional)"
            placeholder="Enter code…"
            type="text"
            value={state.promotioncode}
            onChange={handleChange}
          />
          <br />
          <div className="extended-box">
            <PasswordValid uppercase="" number="true" special="false" long="true" />
            <Input
              label="Create your password"
              placeholder="Enter a password…"
              type="password"
              name="password"
              className="password"
              value={state.password}
              onChange={handleChange}
            />
            <Input
              label="Re-enter your password"
              placeholder="Re-enter a password…"
              type="password"
              name="re-password"
              className="password"
              value={state.repassword}
              onChange={handleChange}
            />
            <div className="mt-4">I'm not a robot</div>
            <br />
            <Row gutter={30}>
              <Col span={24} className="text-center pb-4">
                <a onClick={submitForm} href="javascript: void(0);">
                  <SmallButton title="Create Account Now" />
                </a>
              </Col>
            </Row>
          </div>
        </form>
      </div>
    </styleWrapper>
  );
}

export default SignupForm;

const StyleWrapper = styled.div`
 
    .fancy-box {
      border-radius: 22px;
      box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
      background: rgb(255, 255, 255);
      padding: 40px 50px 25px 50px;
      input {
        font-size: 16px;
        padding: 7px 12px;
      }
    }
  }
`;
